import * as React from 'react';
import { Slot } from '@radix-ui/react-slot';
import { type VariantProps } from 'class-variance-authority';
import { buttonVariants } from './button-variants.ts';
import { cn } from '../../lib/utils.ts';

function Button({
  className,
  variant,
  size,
  labelVariant,
  asChild = false,
  ...props
}: React.ComponentProps<'button'> &
  VariantProps<typeof buttonVariants> & {
    asChild?: boolean;
  }) {
  const Comp = asChild ? Slot : 'button';

  return (
    <Comp
      data-slot="button"
      className={cn(buttonVariants({ variant, size, labelVariant }), className)}
      {...props}
    />
  );
}

export { Button };
